import { motion } from "framer-motion";

export function Example() {
  return (
    <motion.div
      style={{
        width: 150,
        height: 150,
        borderRadius: 30,
        backgroundColor: "#fff",
        y: -90
      }}
      animate={{ y: 70, rotate: 360, scale: 0.8 }}
      transition={{
        delay: 1,
        duration: 2,
        ease: [0.075, 0.82, 0.165, 1],
        repeat: Infinity,
        repeatType: "reverse",
        rotate: {
          delay: 1,
          duration: 2,
          ease: "linear",
          repeat: Infinity
        },
        scale: { delay: 1, type: "spring", damping: 3 }
      }}
    />
  );
}
